import { useCallback } from 'react';
import { ESRI_MAP_MAX_ZOOM_LEVEL, ESRI_MAP_MIN_ZOOM_LEVEL } from '../configurations';
import { MapView } from '../constructors';

export type UseZoomInAndOutControl = {
    mapView?: MapView;
    maxZoomLevel?: number;
    minZoomLevel?: number;
};
export const useZoomInAndOutControl = ({
    mapView,
    maxZoomLevel = ESRI_MAP_MAX_ZOOM_LEVEL,
    minZoomLevel = ESRI_MAP_MIN_ZOOM_LEVEL,
}: UseZoomInAndOutControl) => {
    const onZoomIn = useCallback(
        function onZoomIn(): void {
            if (mapView !== undefined && mapView.zoom !== maxZoomLevel) {
                mapView.zoom += 1;
            }
        },
        [mapView, maxZoomLevel]
    );

    const onZoomOut = useCallback(
        function onZoomOut(): void {
            if (mapView !== undefined && mapView.zoom !== minZoomLevel) {
                mapView.zoom -= 1;
            }
        },
        [mapView, minZoomLevel]
    );

    return {
        onZoomIn,
        onZoomOut,
    };
};
